export default [
  { id: 1, value: 'credit_card', name: 'Cartão de crédito' },
  { id: 2, value: 'boleto', name: 'Boleto bancário' },
  { id: 3, value: 'voucher', name: 'Voucher' },
  { id: 4, value: 'bank_transfer', name: 'Transferência bancária' },
  { id: 5, value: 'pix', name: 'Pix' },
  { id: 6, value: 'financiamento', name: 'Financiamento' },
  { id: 7, value: 'dinheiro', name: 'Dinheiro' }
]
